<template>
	<div class="judge-gallery-app">
		<router-view></router-view>
	</div>
</template>
<script>

</script>